import type { JSX } from "react";
import type { DeviceProfile } from "../types";
import { formatDate, formatNumber } from "./format";
import { SectionTable } from "./SectionTable";

export const GeoPanel = ({
  profile,
}: {
  profile: DeviceProfile;
}): JSX.Element => (
  <SectionTable
    headers={["Country", "Region", "City", "Count", "First seen", "Last seen"]}
    rows={profile.geo.map((row) => [
      row.country,
      row.region,
      row.city,
      formatNumber(row.count),
      formatDate(row.firstSeen),
      formatDate(row.lastSeen),
    ])}
    emptyLabel="No geo data."
  />
);
